import React from 'react';

import cookie from 'react-cookies';

import { TabBar } from 'antd-mobile';
import 'antd-mobile/dist/antd-mobile.css';

import MainPage from './MainPage';
import MorePage from './MorePage';
import MinePage from './MinePage';
import LoginPage from './LoginPage';
import FormListPage from './FormListPage';
import FormMainPage from './FormMainPage';
import DraftPage from './DraftPage';
import FormDetailPage from './FormDetailPage';
import HandlePage from './HandlePage'
import FormPrintPage from './FormPrintPage';
import FormCommonPage from './FormCommonPage';
import FormDataListPage from './FormDataListPage';
import PcLoginPage from './PcLoginPage';

import { _getDataFormCount } from "../../server";

import "./index.css";

class Index extends React.Component {

    constructor(props) {
        super(props);
        let selectedTab = undefined;
        if (this.props.location.query && this.props.location.query.selectedTab) {
            selectedTab = this.props.location.query.selectedTab;
        } else {
            selectedTab = window.sessionStorage.getItem("index_tab");
        }
        if (!selectedTab) {
            selectedTab = 'mainTab';
        }

        this.state = {
            selectedTab: selectedTab,
            hidden: false,
            unHandleCount: 0,
        };
        this.sid = cookie.load(process.env.TOKEN_KEY);
        if (this.sid) {
            this.getUnHandleCount();
        }
    }

    refresh = () => {
        this.sid = cookie.load(process.env.TOKEN_KEY);
        if (this.sid) {
            this.getUnHandleCount();
        }
    }

    async getUnHandleCount() {
        const res = await _getDataFormCount(this.sid, 2);
        if (res.code === 0) {
            this.setState({ unHandleCount: res.data.count });
        }
    }

    render() {
        return (
            <div className={["wrap", "adapt_iphonex"].join(' ')}>
              <TabBar
                unselectedTintColor="#949494"
                tintColor="#FF884D"
                barTintColor="white"
                tabBarPosition="bottom"
                hidden={this.state.hidden}>
                <TabBar.Item
                  title="首页"
                  key="Main"
                  icon={<img src={require('../../common/images/main_tabbar_bg.png')} style={{width: '22px',height: '22px'}}/>}
                  selectedIcon={<img src={require('../../common/images/main_tabbar_bg_.png')} style={{width: '22px',height: '22px'}}/>}
                  selected={this.state.selectedTab === 'mainTab'}
                  onPress={() => {
                    this.setState({
                      selectedTab: 'mainTab',
                    });
                    window.sessionStorage.setItem("index_tab", 'mainTab');
                  }}>
                  <MainPage />
                </TabBar.Item>
                <TabBar.Item
                  icon={<img src={require('../../common/images/progress_tabbar_bg.png')} style={{width: '22px',height: '22px'}}/>}
                  selectedIcon={<img src={require('../../common/images/progress_tabbar_bg_.png')} style={{width: '22px',height: '22px'}}/>}
                  title="办理"
                  badge={this.state.unHandleCount}
                  key="Handle"
                  selected={this.state.selectedTab === 'handleTab'}
                  onPress={() => {
                    this.setState({
                      selectedTab: 'handleTab',
                    });
                    window.sessionStorage.setItem("index_tab", 'handleTab');
                  }}>
                  <HandlePage unHandleCount = {this.state.unHandleCount}/>
                </TabBar.Item>
                <TabBar.Item
                  key="Plus"
                  icon={<img src={require('../../common/images/plus_bg.png')} style={{width: '32px',height: '32px'}}/>}
                  onPress={() => {this.props.history.push('/formlist')}}>
                  <MainPage />
                </TabBar.Item>
                <TabBar.Item
                  icon={<img src={require('../../common/images/mine_tabbar_bg.png')} style={{width: '22px',height: '22px'}}/>}
                  selectedIcon={<img src={require('../../common/images/mine_tabbar_bg_.png')} style={{width: '22px',height: '22px'}}/>}
                  title="我的"
                  key="mineTab"
                  selected={this.state.selectedTab === 'mineTab'}
                  onPress={() => {
                    this.setState({
                      selectedTab: 'mineTab',
                    });
                    window.sessionStorage.setItem("index_tab", 'mineTab');
                  }}>
                  <MinePage />
                </TabBar.Item>
                <TabBar.Item
                  icon={<img src={require('../../common/images/more_tabbar_bg.png')} style={{width: '22px',height: '22px'}}/>}
                  selectedIcon={<img src={require('../../common/images/more_tabbar_bg_.png')} style={{width: '22px',height: '22px'}}/>}
                  title="更多"
                  key="moreTab"
                  selected={this.state.selectedTab === 'moreTab'}
                  onPress={() => {
                    this.setState({
                      selectedTab: 'moreTab',
                    });
                    window.sessionStorage.setItem("index_tab", 'moreTab');
                  }}>
                  <MorePage callback={this.refresh} />
                </TabBar.Item>
              </TabBar>
          </div>
        );
    }

}

export {
    Index,
    LoginPage,
    FormListPage,
    FormMainPage,
    DraftPage,
    FormDetailPage,
    HandlePage,
    FormPrintPage,
    FormCommonPage,
    FormDataListPage,
    PcLoginPage,
}

const MyPages = {}

export default MyPages;